import _ from 'lodash'
import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import {
  Card,
  CardContent,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  FormLabel,
  Typography,
  Grid,
  withStyles,
} from '@material-ui/core'
import {Link} from 'react-router'
import {bindActionCreators, compose} from 'redux'
import {connect} from 'react-redux'
import qs from 'qs'
import autobind from 'autobind-decorator'
import settings from '../../../config/settings'
import InputValidator from '../common/InputValidator.jsx'
import ValidatedComponent from '../common/ValidatedComponent.jsx'
import Input from '../common/Input'
import Button from '../common/Button'
import PasswordInput from '../common/PasswordInput'
import {createProfile} from '../profile/redux/actions'
import * as Actions from './redux/actions'
// import {FacebookAuthButton} from './SocialAuthButtons.jsx' //TwitterAuthButton
import {phoneRegex, imageFileRegex} from '../constants/Regex'
import styles from './styles/AuthForm.styles'

class Signup extends React.Component {
  constructor() {
    super()

    this.state = {
      email: '',
      password: '',
      confirmPassword: '',
      referralCode: '',
      canSubmit: false,
      acceptTerms: _.get(settings, 'website.automaticAccountAgreement'),
      acceptConsent: false,
      inputState: null,
    }

    this.passwordRef = React.createRef()
    this.confirmPasswordRef = React.createRef()

    this.changeEmail = this.changeEmail.bind(this)
    this.changePassword = this.changePassword.bind(this)
    this.changeConfirmPassword = this.changeConfirmPassword.bind(this)
  }

  componentDidMount() {
    this.getReferralCode()
  }

  getReferralCode() {
    const {referral_code} = qs.parse(document.location.search) // eslint-disable-line camelcase
    this.setState({referralCode: referral_code})
  }

  @autobind
  createUser(event) {
    event.preventDefault()
    const {isComponentValid, createProfile} = this.props
    const {
      company,
      firstName,
      lastName,
      email,
      phoneNumber,
      password,
      avatar,
      referralCode,
    } = this.state
    const registeredFrom = 5
    if (isComponentValid()) {
      createProfile({
        company,
        firstName,
        lastName,
        email,
        phoneNumber,
        password,
        avatar,
        referralCode,
        registeredFrom,
      })
    }
  }

  changeEmail(e) {
    const {value} = e.target
    this.setState(prevState => ({
      email: value,
      canSubmit: value && prevState.password && prevState.confirmPassword,
    }))
  }

  changePassword(e) {
    const {value} = e.target
    this.setState(prevState => ({
      password: value,
      canSubmit: value && prevState.email && prevState.confirmPassword,
    }))
  }

  changeConfirmPassword(e) {
    const {value} = e.target
    this.setState(prevState => ({
      confirmPassword: value,
      canSubmit: value && prevState.email && prevState.password,
    }))
  }

  onProfileImageUpload(e) {
    const avatar = e.target.files.item(0)
    if (!avatar || !imageFileRegex.test(avatar.type)) {
      return
    }

    const reader = new FileReader()
    reader.onload = e => {
      this.setState({
        avatar: e.target.result,
      })
    }
    reader.readAsDataURL(avatar)
  }

  @autobind
  validateConfirmPassword() {
    const {password, confirmPassword} = this.state
    if (password && confirmPassword && password !== confirmPassword) {
      return 'Both passwords must be equal'
    }
  }

  validatePhone() {
    const {phoneNumber} = this.state
    if (!phoneRegex.test(phoneNumber)) {
      return 'Please enter a valid phone number'
    }
  }

  render() {
    const {state} = this
    const {
      errors,
      // socialLoginOAuth1Step1,
      // socialLoginOAuth1Step2,
      // socialLoginOAuth2,
      // provider,
      // oauthToken,
      // oauthTokenSecret,
      // isNoEmailProvidedError,
      isSaving,
      classes,
    } = this.props
    return (
      <div className={classes.page}>
        <Helmet title="Sign up" />
        <Card className={classes.cardCentered} elevation={0}>
          <CardContent className={classes.cardContent}>
            <Typography component="h4" variant="h4" className={classes.title} gutterBottom>
              Create Account
            </Typography>
            <form noValidate>
              <Grid container spacing={32}>
                <Grid item xs={12} className={classes.infoField}>
                  <InputValidator errors={errors.email} shouldValidateOnBlur={true}>
                    <Input
                      type="email"
                      name="email"
                      label="Email"
                      required
                      onChange={this.changeEmail}
                      value={state.email}
                    />
                  </InputValidator>
                </Grid>

                <Grid item xs={12} className={classes.infoField}>
                  <InputValidator
                    forwardRef={this.passwordRef}
                    errors={errors.password}
                    shouldValidateOnBlur={true}
                    customValidation={() => {
                      return this.validateConfirmPassword()
                    }}
                    className={this.state.inputState}
                  >
                    <PasswordInput
                      name="password"
                      label="Password *"
                      required
                      onChange={this.changePassword}
                      value={state.password}
                    />
                  </InputValidator>
                </Grid>

                <Grid item xs={12} className={classes.infoField}>
                  <InputValidator
                    forwardRef={this.confirmPasswordRef}
                    shouldValidateOnBlur={true}
                    customValidation={() => {
                      return this.validateConfirmPassword()
                    }}
                    className={this.state.inputState}
                  >
                    <PasswordInput
                      name="password-confirm"
                      label="Confirm Password *"
                      required
                      onChange={this.changeConfirmPassword}
                      value={state.confirmPassword}
                    />
                  </InputValidator>
                </Grid>

                {!_.get(settings, 'website.automaticAccountAgreement') ? (
                  <Grid item xs={12} className={classes.infoField}>
                    <FormLabel>Terms and Conditions</FormLabel>
                    <InputValidator canShowLabel={false} errors={errors.acceptTerms}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            id="terms"
                            name="terms-and-conditions"
                            checked={state.acceptTerms}
                            onChange={e => this.setState({acceptTerms: e.target.checked})}
                            value="accept_terms"
                          />
                        }
                        label={
                          <span>
                            I agree to the{' '}
                            <a href="/equity-terms" target="_blank" rel="noopener noreferrer">
                              Terms of Use
                            </a>
                            ,{' '}
                            <a href="/equity-privacy" target="_blank" rel="noopener noreferrer">
                              Privacy Policy
                            </a>{' '}
                            and{' '}
                            <a href="/compensation" target="_blank" rel="noopener noreferrer">
                              Compensation Disclaimer
                            </a>
                            .
                          </span>
                        }
                      />
                    </InputValidator>
                  </Grid>
                ) : null}

                <Grid item xs={12} className={classes.submitButton}>
                  <Button
                    type="submit"
                    name="btn-create"
                    variant="contained"
                    onClick={this.createUser}
                    disabled={!state.canSubmit}
                    style={{width: '200px'}}
                  >
                    {isSaving ? (
                      <CircularProgress color="surface.light" size={26} />
                    ) : (
                      'Create Account'
                    )}
                  </Button>
                </Grid>

                {_.get(settings, 'website.socialLogins')
                  ? // <Grid item xs={12} className={classes.infoField}>
                    //   <Typography
                    //     component="h3"
                    //     variant="subtitle1"
                    //     className={classes.titleNoMar}
                    //     gutterBottom
                    //   >
                    //     Or create one with an existing social account
                    //   </Typography>
                    //   <Grid container justify="center" spacing={16}>
                    //     <Grid item xs="auto" className={classes.title}>
                    //       <FacebookAuthButton
                    //         fbAppId={settings.fbAppId}
                    //         onSendAuthRequest={socialLoginOAuth2.bind(this)}
                    //         isNoEmailProvidedError={isNoEmailProvidedError && provider === 'facebook'}
                    //       />
                    //     </Grid>
                    //   </Grid>
                    // </Grid>
                    null
                  : null}
                {_.get(settings, 'website.automaticAccountAgreement') ? (
                  <Grid item xs={12}>
                    <Typography
                      component="p"
                      variant="caption"
                      className={classes.titleNoMar}
                      gutterBottom
                    >
                      By signing up, you agree to our{' '}
                      <a
                        href="https://campaigntester.com/terms-and-conditions/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={classes.linkNoVisitedColor}
                      >
                        terms and conditions
                      </a>{' '}
                      and{' '}
                      <a
                        href="https://campaigntester.com/privacy-policy/ "
                        target="_blank"
                        rel="noopener noreferrer"
                        className={classes.linkNoVisitedColor}
                      >
                        privacy policy
                      </a>
                    </Typography>
                  </Grid>
                ) : null}
                <Grid item xs={12} className={classes.infoField}>
                  <Typography style={{fontSize: 16}}>
                    Have an account?{' '}
                    <Link to="/login" className={classes.link}>
                      Login
                    </Link>
                  </Typography>
                </Grid>
              </Grid>
            </form>
          </CardContent>
        </Card>
        <div className="push" />
      </div>
    )
  }
}

Signup.displayName = 'Signup'

Signup.contextTypes = {
  router: PropTypes.object.isRequired,
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({...Actions, createProfile}, dispatch)
}

function mapStateToProps(state) {
  const {oauthToken, oauthTokenSecret, isNoEmailProvidedError, provider} = state.auth
  return {
    ...state.signup,
    oauthToken,
    oauthTokenSecret,
    isNoEmailProvidedError,
    provider,
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles),
  ValidatedComponent,
)(Signup)
